<template lang="pug">
.page-loading
  v-dialog(v-model="actived"
    hide-overlay
    persistent
    width="300")
    v-card(color="primary"
      dark)
      v-card-text 讀取中
        v-progress-linear(color="white"
          class="mb-0"
          indeterminate)
</template>

<script>
export default {
  name: "PageLoading",
  props: {
    actived: {
      type: Boolean,
      default: true
    }
  }
};
</script>
